import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export interface IClaimsFacilities {
  OfficeType: string | null;
  RmiCity: string | null;
  RmiCompanyId: string | null;
  RmiCountry: string | null;
  RmiFax: string | null;
  RmiIntlZip: string | null;
  RmiLastName: string | null;
  RmiOutsideId: string | null;
  RmiPhone: string | null;
  RmiProvKeyId: string | null;
  RmiProvMpiNo: string | null;
  RmiState: string | null;
  RmiStreet: string | null;
  RmiType: string | null;
  RmiUid: string | null;
  RmiZip: string | null;
}

export interface IFacilities {
  AddressId: string | null;
  City: string | null;
  LastName: string | null;
  Phone: string | null;
  ProvKeyId: string | null;
  State: string | null;
  Street: string | null;
  Zip: string | null;
}

export const getFacilities = (search: any) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_FACILITIES_REQUEST });

  return api.authorization.facilities.get(search)
    .then((res: any) => {

      dispatch({
        type: types.GET_FACILITIES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_FACILITIES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getClaimsFacilities = (search: any) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_CLAIMS_FACILITIES_REQUEST });

  return api.authorization.facilities.getClaimsFacilities(search)
    .then((res: any) => {

      dispatch({
        type: types.GET_CLAIMS_FACILITIES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_CLAIMS_FACILITIES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
